import React, { useState } from 'react';
import './Navbar.css';
import { FaBars, FaTimes } from 'react-icons/fa';

export const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(prev => !prev);

  return (
    <nav className="navbar" role="navigation" aria-label="Main navigation">
      {/* This header (logo + menu icon) will be visible ONLY on mobile via CSS */}
      <div className="nav-header">
        <h2 className="logo">&lt;Ragul /&gt;</h2>

        <button
          className="menu-icon"
          onClick={toggleMenu}
          aria-expanded={isMenuOpen}
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
        >
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* nav-links: on desktop it's visible as a centered horizontal list;
          on mobile it becomes the slide-down menu (controlled by .active). */}
      <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
        <li><a href="#Hero" onClick={() => setIsMenuOpen(false)}>Me</a></li>
        <li><a href="#About" onClick={() => setIsMenuOpen(false)}>About</a></li>
        <li><a href="#Experience-Skills" onClick={() => setIsMenuOpen(false)}>Experience & Skills</a></li>
        <li><a href="#Projects" onClick={() => setIsMenuOpen(false)}>Projects</a></li>
        <li><a href="#contact" onClick={() => setIsMenuOpen(false)}>Contact</a></li>
      </ul>
    </nav>
  );
};
